module.exports = __webpack_public_path__ + "f2ad0ff9f53bbfa223c9340cb4b6c43a.svg";